import React from "react";
import { PiMapPinThin } from "react-icons/pi";
import i18next from "i18next";
import cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import gate from "../../images/map/icons/gated-community.jpeg";
import micro from "../../images/map/icons/micromobility.jpeg";
import mixedBuilding from "../../images/map/icons/mixed-building.jpeg";

import walkaways from "../../images/map/icons/walkaways.jpeg";
import location from "../../images/map/icons/strategic-location.jpeg";
import schools from "../../images/map/icons/schools.jpeg";
import daycare from "../../images/map/icons/daycare.jpeg";
import park from "../../images/map/icons/central-parking.jpeg";
import basement from "../../images/map/icons/basement-parking.jpeg";
import plaza from "../../images/map/icons/plaza.jpeg";

function Amenities() {
  const { t } = useTranslation();
  // https://saroojdevelopment.com/laravel/public/api/storage/${videoSrc}`
  const currentLanguageCode = cookies.get("i18next") || "en";
  return (
    <div
      className={`flex font-[500]  flex-col px-[3%] py-[3%] ${
        currentLanguageCode === "ar" && "text-right"
      }`}
    >
      <h1
        className={`text-[2.5vw] px-[2%]  xl:w-[100%] xl:text-[35px] font-[cairo] ${
          currentLanguageCode === "ar"
            ? "text-right w-[100%] "
            : "text-left w-[50%]"
        }`}
      >
        {t("amenities.title")}
      </h1>

      <div className=" justify-center gap-[3%] xl:gap-[5%] py-[2%] text-center flex flex-wrap w-[100%]">
        <div className=" w-[260px] 2xl:w-[200px] h-[fit-content]">
          <img src={gate} alt="" />
          <p className="text-[21px]"> {t("amenities.option1")}</p>
        </div>
        <div className=" w-[260px] 2xl:w-[200px] h-[fit-content]">
          <img src={location} alt="" />
          <p className="text-[21px]"> {t("amenities.option2")}</p>
        </div>
        <div className=" w-[260px] 2xl:w-[200px] h-[fit-content]">
          <img src={micro} alt="" />
          <p className="text-[21px]"> {t("amenities.option3")}</p>
        </div>

        <div className=" w-[260px] 2xl:w-[200px] h-[fit-content]">
          <img src={walkaways} alt="" />
          <p className="text-[21px]"> {t("amenities.option4")}</p>
        </div>

        <div className=" w-[260px] 2xl:w-[200px] h-[fit-content]">
          <img src={mixedBuilding} alt="" />
          <p className="text-[21px]"> {t("amenities.option5")}</p>
        </div>
        <div className=" w-[260px] 2xl:w-[200px] h-[fit-content]">
          <img src={basement} alt="" />
          <p className="text-[21px]">{t("amenities.option6")}</p>
        </div>
        <div className=" w-[260px] 2xl:w-[200px] h-[fit-content]">
          <img src={park} alt="" />
          <p className="text-[21px]">{t("amenities.option7")}</p>
        </div>

        <div className=" w-[260px] 2xl:w-[200px] h-[fit-content]">
          <img src={plaza} alt="" />
          <p className="text-[21px]">{t("amenities.option8")}</p>
        </div>
        <div className=" w-[260px] 2xl:w-[200px] h-[fit-content]">
          <img src={daycare} alt="" />
          <p className="text-[21px]">{t("amenities.option9")}</p>
        </div>
        <div className=" w-[260px] 2xl:w-[200px] h-[fit-content]">
          <img src={schools} alt="" />
          <p className="text-[21px]">{t("amenities.option10")}</p>
        </div>
      </div>
    </div>
  );
}

export default Amenities;
